import httpManager from "@/app/shared/utils/httpManager";

export async function downloadReport(id: number, formState: any) {
  const url = `/chatbots/${id}/answers-download/?start_date=${formState.startDate}&end_date=${formState.endDate}`;

  const response = await httpManager.getBlob(url);

  return response;
}
